import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Domain feature parameters */
export interface DomainParams {
  /** Reference to parent function element */
  of: string;
}

export const DOMAIN_DEFAULT_PARAMS: Omit<DomainParams, 'of'> = {};

/**
 * Default theme for domain feature.
 * Light sky-blue shading for regions where the function is defined.
 * Use color shades (e.g. 'sky-50', 'green-100') to control lightness — no separate opacity.
 */
export const DOMAIN_DEFAULTS: FeatureStyleNode = {
  polygon: {
    visible: true,
    fillColor: 'sky-50',
    strokeWidth: 0,
  },
  line: {
    color: 'sky-300',
    dash: 3,
    strokeWidth: 2,
    visible: true,
  },
};
